import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { queryClient } from '../../../APIs/QueryClient'
import * as React from 'react'
import { useUpdateScreenCollectionStatus } from '../../../APIs/Hooks/ScreenCollectionHooks'
import { useParams } from 'react-router-dom'

function CompleteCollectionDialog({
  open,
  setOpen,
}: {
  open: boolean
  setOpen: any
}) {
  const { collection_id } = useParams()
  const { mutate: updateStatus } =
    useUpdateScreenCollectionStatus(collection_id)
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>{'Confirm Complete'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The collection will be updated to 'COMPLETE' and you will no longer be
          able to edit any aspect of this request.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            setOpen(false)
            updateStatus('CPT', {
              onSuccess: async () => {
                await queryClient.invalidateQueries({
                  queryKey: [
                    'ScreenCollectionService',
                    'getScreenCollection',
                    collection_id,
                  ],
                })
              },
            })
          }}
          color="primary"
        >
          Complete Collection
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default CompleteCollectionDialog
